import React from 'react';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withMountListener } from '@beef/react/enhancers';
import { Sidebar } from "../../../../components/Sidebar";
import { Search } from "./Search";
import { selectIsOpenSidebar } from "../../store/slices/search/selectors";
import { ActionSearch } from "../../store/slices/search/actions";
import style from "./styles.pcss";
var cn = classNames.bind(style);
var SearchSideBar = function SearchSideBar(_ref) {
  var isOpen = _ref.isOpen,
    onClickOutside = _ref.onClickOutside;
  return /*#__PURE__*/React.createElement(Sidebar, {
    className: cn('sidebar'),
    isOpen: isOpen,
    onClickOutside: onClickOutside,
    position: "right",
    style: {
      zIndex: 555
    }
  }, /*#__PURE__*/React.createElement(Search, {
    className: cn('search-sidebar'),
    isDesktop: true
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    isOpen: selectIsOpenSidebar(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClickOutside: function onClickOutside() {
      return dispatch(ActionSearch.toggleOpenSidebar(false));
    },
    onUnmount: function onUnmount() {
      return dispatch(ActionSearch.toggleOpenSidebar(false));
    }
  };
};
export var SearchSideBarRC = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(SearchSideBar);